module.exports = __webpack_public_path__ + "static/img/news_17.cdf467b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_17.jpg
// module id = 1aLp
// module chunks = 2